import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from "html5-qrcode";
import { useNavigate } from 'react-router-dom';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

const QRScanner = () => {
    const [show, setShow] = useState(false);
    const [result, setResult] = useState("");
    const qrCodeScanner = useRef(null);
    const isOnline = useOnlineStatus();
    const videoContainerRef = useRef(null);
    let navigate = useNavigate();

    useEffect(() => {
        if (result !== "") {
            // Block navigation if offline
            if (!isOnline) {
                console.log('Cannot navigate from QR scan - device is offline');
                setResult("");
                setShow(false);
                return;
            }

            navigate("contact/" + result);
        }
    }, [result, navigate, isOnline]);

    useEffect(() => {
        if (show) {
            qrCodeScanner.current = new Html5Qrcode("video-container");

            qrCodeScanner.current
                .start(
                    { facingMode: "environment" }, // Use rear camera
                    {
                        fps: 10, // Frames per second for scanning
                        qrbox: { width: 250, height: 250 }, // Scanning box size
                    },
                    (decodedText) => {
                        setResult(decodedText);
                    },
                    (errorMessage) => {
                        console.warn("QR Code scanning error:", errorMessage);
                    }
                )
                .catch((err) => {
                    console.error("Error starting QR Code scanner:", err);
                });
        }

        return () => {
            if (qrCodeScanner.current) {
                qrCodeScanner.current.stop().catch((err) => {
                    console.error("Error stopping QR Code scanner:", err);
                });
            }
        };
    }, [show]);

    const startScanning = () => {
        // Block scanning if offline
        if (!isOnline) {
            console.log('Cannot start scanning - device is offline');
            return;
        }

        setResult("");
        setShow(true);
    };

    const stopScanning = () => {
        setResult("");
        setShow(false);
    };

    return (
        <>
            {show ? (
                <>
                    <div className="mb-1" ref={videoContainerRef}>
                        <div id="video-container" style={{ width: '100%' }}></div>
                    </div>
                    <div>
                        <button
                            className="add-lead custom-btn mb-3"
                            onClick={stopScanning}
                            disabled={!isOnline}
                            style={{ opacity: isOnline ? 1 : 0.6, cursor: isOnline ? 'pointer' : 'not-allowed' }}
                        >
                            Scan abbrechen
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <div>
                        <button
                            className="add-lead custom-btn mb-3"
                            onClick={startScanning}
                        >
                            <p className="m-0">
                                <i className="bi bi-qr-code-scan me-2 text-light"></i> Scan starten
                            </p>
                        </button>
                    </div>
                </>
            )}
            {result && <p>Result: {result}</p>}
        </>
    );
};

export default QRScanner;
